import { Injectable } from "@angular/core";
import { RealtimeGateFaultResponse } from "../../../models/ws/realtimeGateFault";
import {
  RealtimeSubscriptionHandle,
  RealtimeSubscriptionRequest,
  RealtimeSubscriptionService,
} from "../realtime-subscription.service";

export interface GateFaultSubscriptionDescriptor extends RealtimeSubscriptionRequest {
  entityType: string;
  entityId: readonly string[];
  lang?: string | null;
}

export type GateFaultSubscriptionHandle = RealtimeSubscriptionHandle<
  RealtimeGateFaultResponse,
  GateFaultSubscriptionDescriptor
>;

@Injectable({
  providedIn: "root",
})
export class GateFaultWebsocketService extends RealtimeSubscriptionService<
  RealtimeGateFaultResponse,
  GateFaultSubscriptionDescriptor
> {
  protected readonly PATH = "gateFaults";
  protected readonly VERSION = 2;
}
